export default {"src":"/_next/static/media/coins.aa4fd988.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};